<template>
  
    <div class="flex flex-col lg:flex-row flex-wrap">

        <div v-for="(oneBusiness) in business" :key="oneBusiness.id" class="lg:mx-4" >

            <div>
                
                <business-card :myBusiness="oneBusiness" :showInfoMethod="showInfoMethod"
                 :showSessionsMethod="showSessionsMethod"/>
            </div>
        </div>


    </div>

</template>

<script>

import BusinessCard from '../cards/CustomerBusinessCard';

export default {

    props:{

        business: {

            type: Array,
        },

        showInfoMethod: {

            type: Function
        },

        showSessionsMethod: {

            type: Function
        },
    },

    components:{

        BusinessCard
    }

}
</script>

<style>

</style>